import { __makeTemplateObject } from "tslib";
import { usePlotContext } from '../context';
import React from 'react';
import { css } from 'emotion';
/**
 * Renders absolutely positioned element on top of the uPlot's plotting area (axes are not included!).
 * Useful when you want to render some overlay with canvas-independent elements on top of the plot.
 */
export var XYCanvas = function (_a) {
    var children = _a.children;
    var plotContext = usePlotContext();
    var plotInstance = plotContext.getPlotInstance();
    if (!plotInstance) {
        return null;
    }
    return (React.createElement("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: absolute;\n        overflow: visible;\n        left: ", "px;\n        top: ", "px;\n      "], ["\n        position: absolute;\n        overflow: visible;\n        left: ", "px;\n        top: ", "px;\n      "])), plotInstance.bbox.left / window.devicePixelRatio, plotInstance.bbox.top / window.devicePixelRatio) }, children));
};
var templateObject_1;
//# sourceMappingURL=XYCanvas.js.map